<template>
    <div class="member-search">
        <loading :active="loading"
                 :can-cancel="true"
                 :on-cancel="onCancel"
                 :is-full-page="fullPage">
        </loading>

      <article class="myo_search_area">
        <form name='form_search' id="form_search" v-on:submit.prevent="submitForm">
            <input type="hidden" name="order" id="order">
            <input type="hidden" name="sort" id="sort">
            <section class="myo_condition_box">
                <div class="relative z-50">
                    <dateForm @set_s_date="set_s_date" @set_e_date="set_e_date" ></dateForm>
                </div>
                <dl class="myo_search_list">
                  <dt>{{ i18n.myoffice.Order.ordno }}</dt>
                  <dd>
                    <input type="text" name="keyword1" v-model="this.keyword1"  class="myo_search_input2">
                  </dd>
                </dl>
                <div class="myo_accordion">
                    <div class="accordion_item">
                        <a class="accordion_tit" href="#n">{{ i18n.myoffice.myoSearchForm.searchSetting }} <span class="accordion_sub_tit">{{ i18n.myoffice.moreview }}</span>
                            <div class="bmenu x7"><span class="btop"><i class="fas fa-chevron-down"></i></span></div></a>
                        <div class="accordion_cont w-full">
                            <div class="lg:grid lg:grid-cols-4 lg:gap-2">
                                <div class="w-full z-[14] relative" v-show="this.rank_cd != '00'">
                                    <countryForm @set_bz_cd="set_bz_cd" :bz_cd="bz_cd"></countryForm>
                                </div>
                                <div class="w-full z-[13] relative">
                                    <orderClassification @set_ord_kind="set_ord_kind" :ord_kind = "9"></orderClassification>
                                </div>
                                <div class="w-full z-[12] relative" v-show="this.rank_cd != '00'">
                                    <ordeType @set_kind_cd="set_kind_cd"></ordeType>
                                </div>
                                <div class="w-full z-[11] relative">
                                    <transactionStatus @set_rcpt_yns="set_rcpt_yns"></transactionStatus>
                                </div>
<!--                                <div class="z-10 col-span-4  relative">-->
<!--                                    <orderMeMultiCode  @set_userkind_type="set_userkind_type" ></orderMeMultiCode>-->
<!--                                </div>-->
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div class="myo_condition_search">
                <button type="reset" onclick="location.replace('/MyOrderList')" class="reset_btn">{{ i18n.myoffice.Refresh }}</button>
                <button type="submit" id="submit" class="search_btn">{{ i18n.myoffice.Search }}</button>
            </div>
        </form>
      </article>
    </div>

    <p class="p_alert">{{ i18n.myoffice.myofficeAlert.ClickStarButtonNotice }}</p><!-- 아래 리스트 중 회원번호 옆 별을 클릭(터치)하여 회원을 즐겨찾기에 등록 및 삭제가 가능합니다. -->

    <div class="summary position_relate_box mt-6" style="clear: both;"><strong>Total</strong> <em>{{ total_count }}</em></div>

        <input type=hidden name=exec_mode value=''>
        <div class="relative overflow-x-auto shadow-md sm:rounded-lg mt-4">

        <table id="order_list" class="relative overflow-x-auto shadow-md sm:rounded-lg w-full">
            <thead>
            <tr class="text-sm text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 border-b">
                <th class="px-6 py-3 whitespace-nowrap">No</th>
                <th class="px-6 py-3 whitespace-nowrap">{{ i18n.myoffice.Order.ordKind}}</th>
                <th class="px-6 py-3 whitespace-nowrap">{{ i18n.myoffice.Order.ordno}}</th>
                <th class="px-6 py-3 whitespace-nowrap" v-show="this.rank_cd != '00'">{{ i18n.myoffice.MemberId}}</th>
                <th class="px-6 py-3 whitespace-nowrap" v-show="this.rank_cd != '00'">{{ i18n.myoffice.memberName}}</th>
                <th class="px-6 py-3 whitespace-nowrap">{{ i18n.myoffice.Order.orderDate}}</th>
                <th class="px-6 py-3 whitespace-nowrap">{{ i18n.myoffice.Order.depositdate}}</th>
                <th class="px-6 py-3 whitespace-nowrap">{{ i18n.myoffice.Order.amount}}</th>
                <th class="px-6 py-3 whitespace-nowrap">{{ i18n.myoffice.Order.bv}}</th>
                <th class="px-6 py-3 whitespace-nowrap">{{ i18n.myoffice.Order.type}}</th>
                <th class="px-6 py-3 whitespace-nowrap" v-show="this.rank_cd != '00'">{{ i18n.myoffice.Country2}}</th>
                <th class="px-6 py-3 whitespace-nowrap">{{ i18n.myoffice.Order.depositamount}}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(Value,index) in orderList" :class="{'bg-[#ffc4c4]' : Value.ord_kind == 0 , 'bg-white'  : Value.ord_kind != 0}" class=" border-b dark:bg-gray-800 dark:border-gray-700">
                <td class="px-6 py-4 w-3 text-center font-medium text-gray-900 dark:text-white whitespace-nowrap">{{ total_count - ((page-1)*20 + index) }}</td>
                <td class="px-6 py-3 w-3 whitespace-nowrap">{{ Value.ord_kinds }}</td>
                <td class="px-6 py-3 w-3 whitespace-nowrap"><a class="text-blue-400 underline underline-offset-1" :href="Value.href">{{ Value.ord_no }}</a></td>
                <td class="px-6 py-3 w-3 whitespace-nowrap" v-show="this.rank_cd != '00'">{{ Value.userid }}</td>
                <td class="px-6 py-3 w-3 whitespace-nowrap" v-show="this.rank_cd != '00'">{{ Value.username }}</td>
                <td class="px-6 py-3 w-3 whitespace-nowrap">{{ Value.ord_date2 }}</td>
                <td class="px-6 py-3 w-3 whitespace-nowrap">{{ Value.acc_date2 }}</td>
                <td class="px-6 py-3 w-3 whitespace-nowrap">{{ formatPrice(Value.ord_amt,2) }}</td>
                <td class="px-6 py-3 w-3 whitespace-nowrap">{{ formatPrice(Value.ord_pv,1) }}</td>
                <td class="px-6 py-3 w-3 text-center whitespace-nowrap">{{ Value.ord_kinds }}</td>
                <td class="px-6 py-3 w-3 whitespace-nowrap" v-show="this.rank_cd != '00'">{{ Value.bz_cd }}</td>
                <td class="px-6 py-3 w-3 whitespace-nowrap">{{ Value.rcpt_yns }}</td>
            </tr>
            <tr class="h-2" v-if="total_count == 0">
                <td class="text-left md:text-center pl-5 py-5" colspan="13">{{ this.list_msg }}</td>
            </tr>

            </tbody>
        </table>
        </div>
  <div style="  display: flex;  align-items: center;   justify-content: center;" class="mt-4">
    <v-pagination
      v-model="page"
      :pages=total_page
      :range-size="1"
      active-color="#DCEDFF">
    </v-pagination>
  </div>
</template>
<script>
import dateForm from '../../searchForm/dateForm.vue'
import memberForm from '../../searchForm/memberForm.vue'
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import VueSimpleAlert from "vue3-simple-alert";
import divisionForm from '../../searchForm/divisionForm.vue'
import countryForm from '../../searchForm/countryForm.vue'
import orderClassification from '../../searchForm/orderClassification.vue'
import rankForm from '../../searchForm/rankForm.vue'
import ordeType from '../../searchForm/ordeType.vue'
import transactionStatus from '../../searchForm/transactionStatus.vue'
import orderMeMultiCode from '../../searchForm/orderMeMultiCode.vue'


export default {
    name: "MyOrderList",
    components : {
        dateForm,
        memberForm,
        VPagination,
        Loading,
        orderClassification,
        divisionForm,
        countryForm,
        rankForm,
        ordeType,
        transactionStatus,
        orderMeMultiCode
    },
    data: () => ({
        i18n: window.i18n,
        orderList : [],
        total_count : 0,
        page : 1,
        total_page : 1,
        loading : false,
        fullPage : true,
        size: '45px',
        sort: 'desc',
        s_date: '',
        e_date: '',
        keyword1 : '',
        list_msg : 'Click \'Search\' to view the data',
        ord_kind: '',
        userkind_type : '',
        bz_cd : '',
        rank_cd : '',
        kind_cd : '',
        rcpt_yns : '',
    }),
    computed : {

    },
    props:['ord_no'],
    watch : {
        page: function(){
            $("#submit").click();
        }
    },
    created : function (){
      this.set_ord_kind();
      this.submitForm();
    },
    mounted : function(){
      this.rank_cd = window.Laravel.rank_cd;
    },
    methods : {
        submitForm : function (event){
            //event.preventDefault();
            this.loading = true;
            axios.post(window.Laravel.back_url+'/api/getMyOrderList',{
                s_date : this.s_date,
                e_date : this.e_date,
                page : this.page,
                sort: this.sort,
                ord_kind: this.ord_kind ?? '9',
                bz_cd: this.bz_cd,
                userkind_type: this.userkind_type,
                kind_cd: this.kind_cd,
                rcpt_yns: this.rcpt_yns,
                keyword1 : this.keyword1,
            },{headers: { Authorization: 'Bearer ' + window.Laravel.access_token }}).then(response => {
                this.orderList = response.data.list.data;
                this.total_count = response.data.total_count;
                this.total_page = parseInt(this.total_count/20)+parseInt(this.total_count%20 > 0 ? 1 : 0);
                this.loading = false;
                if(this.total_count == 0){
                    VueSimpleAlert.alert("There are no search results","","",{});
                    this.list_msg = "No data";
                }

            });

        },
        updatePageHandler(page){
            //this.page = page;
        },
        notCheck(id){
            return this.order != id ? true : false;
        },
        asconCheck(id){
            return this.order == id && this.sort == "asc" ? true : false;
        },
        descCheck(id){
            return this.order == id && this.sort == "desc" ? true : false;
        },
        reSortArray(id){
            this.order = id;
            this.sort = this.sort == "asc" ? "desc" : "asc";
            $("#submit").click();

        },
        set_s_date(s_date){
          this.s_date = s_date;
        },
        set_e_date(e_date){
          this.e_date = e_date;
        },
        set_userkind_type(userkind_type){
            this.userkind_type = userkind_type;
        },
        set_bz_cd(bz_cd){
            this.bz_cd = bz_cd;
        },
        set_ord_kind(ord_kind){
            this.ord_kind = ord_kind;
        },
        set_kind_cd(kind_cd){
            this.kind_cd = kind_cd;
        },
        set_rcpt_yns(rcpt_yns){
            this.rcpt_yns = rcpt_yns;
        },
        formatPrice(value,digit) {
            let val = (value/1).toFixed(digit).replace('.', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },

    }
}

$(document).ready( function () {
});
</script>
